import axios from 'axios'
import router from "@/router";

// 读取配置文件
let config = {
  baseURL: 'https://api.ihbroaster.com/roaster', // 默认值
  timeout: 1200000,
  withCredentials: true
};

// 特殊设备配置：需要反转温度显示的设备名称数组
export let reverseTemperatureDevices = [];

// 异步加载配置文件
const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const configData = await response.json();
    config = {
      baseURL: configData.api.baseURL,
      timeout: configData.api.timeout,
      withCredentials: configData.api.withCredentials
    };
    // 加载特殊设备配置
    if (configData.specialDevices && configData.specialDevices.reverseTemperatureDevices) {
      reverseTemperatureDevices = configData.specialDevices.reverseTemperatureDevices;
    }
  } catch (error) {
    console.warn('Failed to load config.json, using default configuration:', error);
  }
};

// 创建 axios 实例
const Axios = axios.create(config);

Axios.interceptors.request.use(config => {
    if(localStorage.aqbCofeLang != null){
        config.headers['language'] = localStorage.aqbCofeLang;

    }
    config.headers['version'] = '2'; // Set the version header
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token') || ''; // Replace 'token' with your actual token
    return config
},function(error){
    return Promise.reject(error)
});

Axios.interceptors.response.use(response=>{
    if(response.data.status==4003){
        router.replace({path:'/login'})
    }else{
        return response;
    }
},error => {
    router.replace({ path: '/login' });
    return Promise.reject(error)
});

// 初始化配置
loadConfig().then(() => {
  // 更新 axios 实例的配置
  Axios.defaults.baseURL = config.baseURL;
  Axios.defaults.timeout = config.timeout;
  Axios.defaults.withCredentials = config.withCredentials;
});

export default Axios
